import React, { Component } from 'react';
import  './css/IconColorPicker.css';
import PropTypes from 'prop-types';

// export const defaultIcons = [
// 	'home',
// 	'store-alt',
// 	'building',
// 	'hospital',
// 	'industry',
// 	'gas-pump',	
// 	'stop-circle',
// 	'surprise',
// 	'star',
// 	'exclamation-triangle'
// ];
export const defaultIcons = [
	'home',
	'home2',
	'shop',//'store-alt'
	'condo',//building
	'condo2',
	'hospital',
	'factory',//'industry'
	'factory2',
	'fuel',//'gas-pump',	
	'stop-circle',
	'surprise',
	'star',
	'triangle',//'exclamation-triangle'
	'noentry',
	'arrow',
	'circle',
	'cross',
	'flag',
	'police',
	'tower',
	
];

const mapIcons = {
	fuel: 'gas-pump',
	home2: 'icon-home2',
	noentry: 'minus-circle',
	flag: 'icon-flag',
	police: 'icon-man',
	tower: 'broadcast-tower',
	arrow: 'icon-arrow-down',
	circle: 'icon-radio-unchecked',
	triangle :'exclamation-triangle',
	cross: 'icon-cross',
	shop: 'store-alt',
	factory: 'industry',
	factory2: 'icon-home3',
	condo: 'building',
	condo2: 'icon-office'
}



// export const defaultColors = [
// 	'#17202A',
// 	'#873600',
// 	'#C70039',
// 	'#FF5733',
// 	'#F39C12',
// 	'#F4D03F',
// 	'#1F618D',
// 	'#9B59B6',
// 	'#D2B4DE',
// 	'#5DADE2',
// 	'#27AE60',
// 	'#82E0AA',
// 	'#AAB7B8',
	
	
// ];
export const defaultColors = [
	'red',
	'pink',
	'purple',
	'purple-deep',
	'indigo',
	'blue',
	'blue-light',
	'cyan',
	'teal',
	'green',
	'green-light',
	'lime',
	'yellow',
	'amber',
	'orange',
	'orange-deep',
	'brown',
	'grey',
	'grey-blue',
];

export const mapColors = {
	red: "#f44336",
	pink: "#e91e63",
	purple: "#9c27b0",
	"purple-deep": "#673ab7",
	indigo: "#3f51b5",
	blue: "#2196f3",
	'blue-light': "#03a9f4",
	'cyan': "#00bcd4",
	'teal': "#009688",
	'green': "#4caf50",
	'green-light': "#8bc34a",
	'lime': "#cddc39",
	'yellow': "#ffeb3b",
	'amber' : "#ffc107",
	'orange': "#ff9800",
	'orange-deep': "#ff5722",
	'brown': "#795548",
	'grey': "#9e9e9e",
	'grey-blue': "#607d8b",
}

const Icon = ({name, className, ...rest}) => {
	if(mapIcons[name]){
		if(mapIcons[name].indexOf('icon-') > -1){
			return (
				<span 
					className={`icon-icomoon ${mapIcons[name]} ${className ? className : ''}`}
					{...rest}
					aria-hidden="true"></span>
			);
		}else{
			name = mapIcons[name];
		}
	}
		

	return (
		<span 
			className={`fas fa-${name.toLowerCase()} ${className ? className : ''}`}
			{...rest}
			aria-hidden="true"></span>
	);
};

class POIColorPicker extends Component {
 
	constructor(props) {
		super(props);
		this.setWrapperRef = this.setWrapperRef.bind(this); 
		this.toggleDropdown = this.toggleDropdown.bind(this);
		this.handleClickOutside = this.handleClickOutside.bind(this);
		this.setSelectedIcon = this.setSelectedIcon.bind(this);
		this.setSelectedColor = this.setSelectedColor.bind(this);
		this.clearSelected = this.clearSelected.bind(this);
		this.state = {
			dropdownOpen: false,
			selectedIcon: this.props.selectedIcon==""?'home':this.props.selectedIcon,
			selectedColor: this.props.selectedColor==""?'#17202A':this.props.selectedColor
		};
		this.defaultState = this.state;
		//this.props.onIconColorSelected(this.state.selectedIcon,this.state.selectedColor);
	}


	componentDidMount() {
		const {
			defaultIcon,
			defaultColor
		} = this.props;
		console.log("toto componentDidMount",defaultIcon,defaultColor)
		document.addEventListener('mousedown', this.handleClickOutside);
		if (defaultIcon && defaultColor) {
			this.setState({ selectedIcon: defaultIcon ? defaultIcon : defaultIcons[0], selectedColor: defaultColor ? defaultColor : defaultColors[6]});
		}
	}

	componentWillUnmount() {
		document.removeEventListener('mousedown', this.handleClickOutside);
	}

	handleClickOutside(event) {
		if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
			if (this.state.selectedIcon !== '' && this.state.selectColor !== '' && this.props.onSelect) {
				this.props.onSelect({ icon: this.state.selectedIcon, color: this.state.selectedColor });
			} else if (this.props.onSelect && this.state.selectedIcon === '' || this.props.onSelect && this.state.selectedColor === '') {
				this.props.onSelect({});
				this.setState({ selectedIcon: '', selectedColor: ''});
			}
			this.setState({dropdownOpen: false});
		}
	}

	clearSelected(){
		this.setState(this.defaultState);
		if (this.props.onSelect) {
			this.props.onSelect({});
		}
	}

	setWrapperRef(node) {
		this.wrapperRef = node;
	}

	toggleDropdown() {
		this.setState({ dropdownOpen: this.state.dropdownOpen ? false : true });
	}

	setSelectedIcon(icon) {
		this.setState({ selectedIcon: icon});
		this.props.onIconColorSelected(icon,this.state.selectedColor);
	}

	setSelectedColor(color) {
		this.setState({ selectedColor: color });
		this.props.onIconColorSelected(this.state.selectedIcon,color);
	}



	storeIconAndColor() {
		this.toggleDropdown();
		if (this.props.onSelect) {
			this.props.onSelect({icon: this.state.selectedIcon, color: this.state.selectedColor})
		}
	}

	render() {
		const {
			icons,
			colors
		} = this.props;

		const componentIcons = icons ? icons : defaultIcons;

		const componentColors = colors ? colors : defaultColors;
		if(this.props.defaultColor){
			this.state.selectedColor = this.props.defaultColor;
			this.state.selectedIcon = this.props.defaultIcon;
		}
		
		console.log("toto icon",this.state.selectedIcon)
		return (

			<div className={`dropdown icon-picker ${this.state.dropdownOpen ? 'open' : this.props.openAlway?'open':''}`} ref={this.setWrapperRef}>
				<button className="btn btn-default dropdown-toggle" type="button" id="dropdownMenu1" onClick={() => this.toggleDropdown()}>
					{this.state.selectedIcon && this.state.selectedColor ?
						<span className="icon-dropdown-text">
							<Icon name={this.state.selectedIcon} style={{ color: mapColors[this.state.selectedColor]}}/>
						</span>
						:
						<span>Pick icon and Color</span>
					}
					<span className="caret"></span>
				</button>
				<ul className="dropdown-menu" id="dropdownUL" aria-labelledby="dropdownMenu1">
					<li className="header">เลือกสี</li>
					<ul className="icons">
						{componentColors.map((color, index) => {
							return (
								<li key={index} onClick={() => this.setSelectedColor(color)}>
									<span className={`color border-radius ${this.state.selectedColor === color ? 'selected' : ''}`} style={{ backgroundColor: mapColors[color]}}></span>
								</li>
							);
						})}
					</ul>
					<li className="header">เลือกรูป</li>
					<ul className="icons">
						{componentIcons.map((icon, index) => {
							return (
								<li key={index} onClick={() => this.setSelectedIcon(icon)}>
									<span className={`icon-wrapper ${this.state.selectedIcon === icon ? 'selected' : ''}`}>
										<span className="icon">
											<Icon name={icon} />
										</span>
									</span>
								</li>
							);
						})}
					</ul>
					{/*<hr />
					 <button type="button" className="btn btn-danger outline-none" onClick={() => this.clearSelected()}>Cancel</button>
					<button type="button" className="btn btn-success pull-right outline-none" onClick={() => this.storeIconAndColor()}>Save</button> */}
				</ul>
			</div>
		);
	}
}
POIColorPicker.defaultProps = {
	openAlway: false,
	selectedIcon: 'home',
	selectedColor: '#1F618D',
	defaultIcon:'home',
	defaultColor: '#1F618D'
}

POIColorPicker.propTypes = {
	status: PropTypes.bool,
	selectedIcon: PropTypes.string,
	selectedColor: PropTypes.string,
}
export default POIColorPicker;


// WEBPACK FOOTER //
// ./src/app/view/components/UserControl/IconColorPicker/POIColorPicker..js